import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Price } from "../../Price";

import styles from "./Bonus.scss";

const BonusPrice = forwardRef(({ value, ...restProps }, ref) => (
  <span ref={ref} className={styles.priceWrapper}>
    <Price
      tag="span"
      value={value}
      variants={[
        Price.Variant.offering,
        Price.Variant.inlineBlock,
        styles.price,
      ]}
      {...restProps}
    />
  </span>
));

BonusPrice.displayName = "TariffTile.BonusPrice";

BonusPrice.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default BonusPrice;
